import {
  createPlugin,
  createApiFactory,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { finayaAccessApiRef } from './api';
import { FinayaAccessClient } from './api/FinayaAccessClient';
import { rootRouteRef } from './routes';

export const finayaAccessPlugin = createPlugin({
  id: 'finaya-access',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: finayaAccessApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new FinayaAccessClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const FinayaAccessPage = finayaAccessPlugin.provide(
  createRoutableExtension({
    name: 'FinayaAccessPage',
    component: () =>
      import('./components/FinayaAccessPage').then(m => m.FinayaAccessPage),
    mountPoint: rootRouteRef,
  }),
);
